import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";
import { ActivityStatusColors } from "modules/eventActivityStatus/constants";
import { ActivityStatus } from "modules/eventActivityStatus/types";

const useStyles = makeStyles(() => ({
  "@keyframes animRoomChange": {
    from: {
      opacity: 1,
    },
    to: {
      opacity: 0,
    },
  },
  mapAvatarContainer: {
    position: "absolute",
    background: "rgba(255, 255, 255, 0)",
    borderRadius: "50%",
    transition: "transform 0.3s ease-out",
    boxSizing: "border-box",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    pointerEvents: "all",
    "&:hover": {
      bottom: "25px",
      right: "-10px",
      "& button": {
        display: "block",
      },
    },
  },
  animate: {
    animationDuration: "0.5s",
    animationName: "$animRoomChange",
    animationIterationCount: "infinite",
  },
  avatarBorder: {
    borderRadius: "50%",
    width: "100%",
    height: "100%",
    position: "absolute",
    top: "0",
    left: "0",
  },
  mapAvatar: {
    borderRadius: "50%",
    width: "47px",
    height: "47px",
    display: "flex",
    justifyContent: "center",
  },
  grayedOut: {
    filter: "grayscale(1)",
  },
  activityBadge: {
    "& .MuiBadge-badge": {
      height: "16px",
      minWidth: "16px",
      borderRadius: "999px",
      backgroundColor: ({ status }: { status: ActivityStatus | null }) => {
        switch (status) {
          case ActivityStatus.AWAY:
          case ActivityStatus.FOCUSING:
            return ActivityStatusColors[status];
          case ActivityStatus.ACTIVE:
          default:
            return "rgba(0,0,0,0)";
        }
      },
    },
  },
  tooltipText: {
    whiteSpace: "pre-wrap",
  },
  borderEffect: {
    position: "absolute",
    top: "-15px",
    left: "-15px",
    width: "100%",
    height: "100%",
    borderRadius: "50%",
    pointerEvents: "none",
  },
  isNetworking: {
    border: "15px solid rgba(233, 190, 37, 0.5)",
    outline: "2px solid rgba(233, 190, 37, 1)",
  },
}));

export default useStyles;
